import { CheckIcon, XIcon } from 'lucide-react';

import { Button } from '../ui/button';

interface FloatingActionButtonsProps {
  onSave: () => void;
  onDiscard: () => void;
  disabled: boolean;
}

export function FloatingActionButtons({ onSave, onDiscard, disabled }: FloatingActionButtonsProps) {
  return (
    <div className='fixed bottom-12 left-1/2 grid w-48 -translate-x-1/2 grid-cols-2 items-center rounded-xl bg-foreground p-0.5 shadow-xl'>
      <Button size='sm' className='w-full' onClick={onSave} disabled={disabled}>
        <CheckIcon />
        Save
      </Button>
      <Button
        variant='none'
        size='sm'
        className='w-full text-background hover:opacity-80'
        onClick={onDiscard}
        disabled={disabled}
      >
        <XIcon />
        Discard
      </Button>
    </div>
  );
}
